import angular from 'angular'
import inputApprove from './inputApprove'
import invoiceAnalysis from './invoiceAnalysis'
import stateAnalysis from './stateAnalysis'
import normal from './normal'

export default angular
    .module('statistics.chartAnalysis', [inputApprove, invoiceAnalysis, stateAnalysis, normal])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('statistics.chartAnalysis', {
            url: '/chartAnalysis',
            template: '<div ui-view></div>',
            abstract: true,
            title: '图表分析',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/chartAnalysis/index.js